module.exports = __webpack_public_path__ + "img/ai_recycle_04.322af1a6.png";